import React, { Component } from "react";
import { Api } from "../../utils/api";
import ExpansionPanel from "@material-ui/core/ExpansionPanel/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Divider from "@material-ui/core/Divider/Divider";
import ExpansionPanelActions from "@material-ui/core/ExpansionPanelActions/ExpansionPanelActions";
import Button from "@material-ui/core/Button/Button";
import { Field, Formik } from "formik";
import Grid from "@material-ui/core/Grid/Grid";
//import TextField from '@material-ui/core/TextField';
import { MaterialSelectFormik } from "../components/select-field.component";
import { TextField } from "formik-material-ui";
import { object, string } from "yup";

const formStatsValidationSchema = object().shape({
  age: string().required("Obrigatório").nullable(),
  gender: string().required("Obrigatório").nullable(),
  motive: string().required("Obrigatório").nullable(),
  mobility: string().required("Obrigatório").nullable(),
  room_type: string().required("Obrigatório").nullable(),
  health_problem: string().required("Obrigatório").nullable(),
  autonomy_level: string().required("Obrigatório").nullable(),
});

export class UserRequestStats extends Component {
  constructor() {
    super();
    this.api = new Api();
    this.genderOptionsPromise = this.genderOptionsPromise.bind(this);
    this.mobilityOptionsPromise = this.mobilityOptionsPromise.bind(this);
    this.autonomyLevelOptionsPromise =
      this.autonomyLevelOptionsPromise.bind(this);
    this.roomTypeOptionsPromise = this.roomTypeOptionsPromise.bind(this);
    this.motivesOptionsPromise = this.motivesOptionsPromise.bind(this);
    this.healthProblemsOptionsPromise =
      this.healthProblemsOptionsPromise.bind(this);
    this.pensionAidsOptionsPromise = this.pensionAidsOptionsPromise.bind(this);
    this.countriesOptionsPromise = this.countriesOptionsPromise.bind(this);
  }

  ///////////////////////// MÉTODOS PARA IR BUSCAR AS OPÇÕES DOS INPUTS /////////////////////////////

  //INPUT GÉNERO
  genderOptionsPromise = async () => {
    const res = await this.api.get("/stats_gender");
    const options = res.data;
    return this.optionsToSelectCode(options);
  };

  //INPUT MOBILIDADE
  mobilityOptionsPromise = async () => {
    const res = await this.api.get("/stats_mobility");
    const options = res.data;
    return this.optionsToSelectCode(options);
  };

  //INPUT AUTONOMIA
  autonomyLevelOptionsPromise = async () => {
    const res = await this.api.get("/stats_autonomy_level");
    const options = res.data;
    return this.optionsToSelectCode(options);
  };

  //INPUT TIPO DE QUARTO
  roomTypeOptionsPromise = async () => {
    const res = await this.api.get("/stats_room_type");
    const options = res.data;
    return this.optionsToSelectCode(options);
  };

  //INPUT MOTIVOS
  motivesOptionsPromise = async () => {
    const res = await this.api.get("/stats_motives");
    const options = res.data;
    return this.optionsToSelect(options);
  };

  //INPUT PROBLEMAS DE SAÚDE
  healthProblemsOptionsPromise = async () => {
    const res = await this.api.get("/stats_health_problems");
    const options = res.data;
    return this.optionsToSelect(options);
  };

  //INPUT AJUDA PENSÃO
  pensionAidsOptionsPromise = async () => {
    const res = await this.api.get("/stats_pension_aids");
    const options = res.data;
    return this.optionsToSelect(options);
  };

  //INPUT PAIS DE ORIGEM
  countriesOptionsPromise = async () => {
    const res = await this.api.get("/countries");
    const options = res.data;
    return this.optionsToSelectName(options);
  };

  //OPÇOES P INPUTS COM PRIMARY KEY EM VARCHAR E LABEL
  optionsToSelectCode = (options) => {
    return options.map((option) => ({
      value: option.code,
      label: option.label,
    }));
  };

  //OPÇOES P INPUTS COM PRIMARY KEY EM ID E LABEL
  optionsToSelect = (options) => {
    return options.map((option) => ({ value: option.id, label: option.label }));
  };

  //OPÇOES P INPUTS COM PRIMARY KEY EM ID E NAME
  optionsToSelectName = (options) => {
    return options.map((option) => ({ value: option.id, label: option.name }));
  };

  render() {
    return (
      <div>
        {this.props.userRequestStats && (
          <Formik
            initialValues={{
              age: this.props.userRequestStats.age,
              gender: this.props.userRequestStats.gender,
              motive: this.props.userRequestStats.motive,
              mobility: this.props.userRequestStats.mobility,
              room_type: this.props.userRequestStats.room_type,
              autonomy_level: this.props.userRequestStats.autonomy_level,
              health_problem: this.props.userRequestStats.health_problem,
              pension_aids: this.props.userRequestStats.pension_aids,
            }}
            validationSchema={formStatsValidationSchema}
            validateOnChange={true}
            validateOnBlur={true}
            onSubmit={(values) => {
              this.props.updateStatsInfo(values);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
              setFieldTouched,
            }) => (
              <form onSubmit={handleSubmit}>
                <ExpansionPanel square>
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="body2">Análise de Situação</Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <Grid container>
                      <Grid item md={2}>
                        <div className="age-input-stats">
                          <Field
                            name="age"
                            label="Idade"
                            variant="outlined"
                            component={TextField}
                            value={values.age}
                            onChange={handleChange}
                          />
                        </div>
                      </Grid>
                      <Grid item md={2}>
                        <div className="input-stats">
                          <Field
                            name="gender"
                            value={values.gender}
                            label="Género"
                            optionsFetcher={this.genderOptionsPromise}
                            onChange={setFieldValue}
                            component={MaterialSelectFormik}
                          />
                        </div>
                      </Grid>
                      <Grid item md={4}>
                        <div className="input-stats">
                          <Field
                            name="motive"
                            value={values.motive}
                            label="Motivo"
                            search
                            optionsFetcher={this.motivesOptionsPromise}
                            onChange={setFieldValue}
                            component={MaterialSelectFormik}
                          />
                        </div>
                      </Grid>
                      <Grid item md={4}>
                        <Field
                          name="mobility"
                          value={values.mobility}
                          label="Mobilidade"
                          optionsFetcher={this.mobilityOptionsPromise}
                          onChange={setFieldValue}
                          component={MaterialSelectFormik}
                        />
                      </Grid>
                      <Grid item md={4}>
                        <div className="input-stats">
                          <Field
                            name="autonomy_level"
                            value={values.autonomy_level}
                            label="Autonomia"
                            optionsFetcher={this.autonomyLevelOptionsPromise}
                            onChange={setFieldValue}
                            component={MaterialSelectFormik}
                          />
                        </div>
                      </Grid>
                      <Grid item md={4}>
                        <div className="input-stats">
                          <Field
                            name="room_type"
                            value={values.room_type}
                            label="Tipo de quarto"
                            optionsFetcher={this.roomTypeOptionsPromise}
                            onChange={setFieldValue}
                            component={MaterialSelectFormik}
                          />
                        </div>
                      </Grid>
                      <Grid item md={4}>
                        <Field
                          name="health_problem"
                          value={values.health_problem}
                          label="Prob. Saude"
                          search
                          optionsFetcher={this.healthProblemsOptionsPromise}
                          onChange={setFieldValue}
                          component={MaterialSelectFormik}
                        />
                      </Grid>
                      <Grid item md={4}>
                        <Field
                          name="pension_aids"
                          value={values.pension_aids}
                          label="Subsistema de Saúde"
                          search
                          optionsFetcher={this.pensionAidsOptionsPromise}
                          onChange={setFieldValue}
                          component={MaterialSelectFormik}
                        />
                      </Grid>
                    </Grid>
                  </ExpansionPanelDetails>
                  <Divider />
                  <ExpansionPanelActions>
                    <Button size="small" type="submit" onClick={handleSubmit}>
                      Save
                    </Button>
                  </ExpansionPanelActions>
                </ExpansionPanel>
              </form>
            )}
          </Formik>
        )}
      </div>
    );
  }
}
